import { render, staticRenderFns } from "./FunClass.vue?vue&type=template&id=c057f000&scoped=true"
import script from "./FunClass.vue?vue&type=script&lang=js"
export * from "./FunClass.vue?vue&type=script&lang=js"
import style0 from "./FunClass.vue?vue&type=style&index=0&id=c057f000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057f000",
  null
  
)

export default component.exports